export enum RegistrationResponse {
  Unknown,
  Sent,
  Success,
  InvalidCaptcha,
  PasswordTooShort,
  InvalidCode,
  InvalidEmail,
  FirstNameRequired,
  LastNameRequired,
  EmailAlreadyExists,
  EmailDoesNotExist
}
